import React from 'react';
import { Button } from 'react-bootstrap';
import auth from '../../services/authentication';


const ProtectedButton = ({accessPath, children, ...others}:any) =>{
    return <Button hidden={!auth.checkPermission(accessPath)} {...others}>{children}</Button>;
}

export default ProtectedButton;